"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _Slider = _interopRequireDefault(require("./CampaignCreator/Slider"));

var _Select = _interopRequireDefault(require("./CampaignCreator/Select"));

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PersonaFilters = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PersonaFilters, _React$Component);

  function PersonaFilters() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PersonaFilters.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.groupedPersonaRecords && Object.keys(this.props.groupedPersonaRecords).length) {
      var _this$props = this.props,
          groupedPersonaRecords = _this$props.groupedPersonaRecords,
          filters = _this$props.filters;
      var maxPopulation = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'population');

      if (filters.population > maxPopulation) {
        this.props.setPopulation(maxPopulation);
      }

      var maxIndex = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'index');

      if (filters.index > maxIndex) {
        this.props.setIndex(Math.floor(maxIndex));
      }

      var maxShareOfAudience = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'shareOfAudience');

      if (filters.shareOfAudience > maxShareOfAudience) {
        this.props.setShareOfAudience(Math.floor(maxShareOfAudience));
      }

      var maxShareOfAttribute = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'shareOfProperty');

      if (filters.shareOfAttribute > maxShareOfAttribute) {
        this.props.setShareOfAttribute(Math.floor(maxShareOfAttribute));
      }
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.groupedPersonaRecords && Object.keys(this.props.groupedPersonaRecords).length) {
      var _this$props2 = this.props,
          groupedPersonaRecords = _this$props2.groupedPersonaRecords,
          filters = _this$props2.filters;
      var maxPopulation = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'population');

      if (filters.population > maxPopulation) {
        this.props.setPopulation(maxPopulation);
      }

      var maxIndex = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'index');

      if (filters.index > maxIndex) {
        this.props.setIndex(Math.floor(maxIndex));
      }

      var maxShareOfAudience = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'shareOfAudience');

      if (filters.shareOfAudience > maxShareOfAudience) {
        this.props.setShareOfAudience(Math.floor(maxShareOfAudience));
      }

      var maxShareOfAttribute = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'shareOfProperty');

      if (filters.shareOfAttribute > maxShareOfAttribute) {
        this.props.setShareOfAttribute(Math.floor(maxShareOfAttribute));
      }
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        groupedPersonaRecords = _this$props3.groupedPersonaRecords,
        themeReset = _this$props3.themeReset,
        isFetchingCategories = _this$props3.isFetchingCategories,
        theme = _this$props3.theme,
        filters = _this$props3.filters,
        categories = _this$props3.categories,
        setTheme = _this$props3.setTheme,
        setShareOfAudience = _this$props3.setShareOfAudience,
        setShareOfAttribute = _this$props3.setShareOfAttribute,
        setIndex = _this$props3.setIndex,
        setPopulation = _this$props3.setPopulation;
    var shareOfAudience = filters.shareOfAudience,
        shareOfAttribute = filters.shareOfAttribute,
        index = filters.index,
        population = filters.population,
        resetShareOfAudience = filters.resetShareOfAudience,
        resetShareOfAttribute = filters.resetShareOfAttribute,
        resetIndex = filters.resetIndex,
        resetPopulation = filters.resetPopulation;
    var maxShareOfAttribute = 100;
    var maxShareOfAudience = 100;
    var maxIndex = 100;
    var maxPopulation = 100;

    if (groupedPersonaRecords && groupedPersonaRecords[0]) {
      maxShareOfAttribute = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'shareOfProperty');
      maxShareOfAudience = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'shareOfAudience');
      maxIndex = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'index');
      maxPopulation = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'population');
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "persona-filters"
    }, /*#__PURE__*/React.createElement(_Select["default"], {
      reset: themeReset,
      selectMessage: "Select Theme",
      loading: isFetchingCategories,
      values: categories,
      onUpdate: setTheme,
      defaultThemes: theme
    }), /*#__PURE__*/React.createElement(_Slider["default"], {
      title: "Population (greater than)",
      min: 0,
      max: maxPopulation,
      reset: resetPopulation,
      valueFormatter: _helpers.formatAsThousands,
      onUpdate: setPopulation,
      defaultValue: population
    }), /*#__PURE__*/React.createElement(_Slider["default"], {
      title: "Share of Audience (greater than)",
      min: 0,
      max: maxShareOfAudience,
      unit: '%',
      reset: resetShareOfAudience,
      onUpdate: setShareOfAudience,
      defaultValue: shareOfAudience
    }), /*#__PURE__*/React.createElement(_Slider["default"], {
      title: "Share of Attribute (greater than)",
      min: 0,
      max: maxShareOfAttribute,
      unit: '%',
      reset: resetShareOfAttribute,
      onUpdate: setShareOfAttribute,
      defaultValue: shareOfAttribute
    }), /*#__PURE__*/React.createElement(_Slider["default"], {
      title: "Index (greater than)",
      min: 0,
      max: maxIndex,
      reset: resetIndex,
      onUpdate: setIndex,
      defaultValue: index
    }));
  };

  return PersonaFilters;
}(React.Component);

exports["default"] = PersonaFilters;